import {html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';

import {TariffFormStore} from './../Storage/tariffStorage';
import {SwsSummary} from "../Pages/swsSummary";
import {formatNumber} from '../utils';

const swsSummaryEls = document.getElementById('swsSummary');

interface Tariff {
    title: string;
    title_long: string;
    media: string;
    zips: number[];
    icon: string;
    description_short: string;
    description: string;
    description_long: string;

    tariff:{
        base_price: any[];
        labor_price: number;
    }
    type: number;
    faqs: {
        title: string,
        answer: string
    }
}

@customElement('sws-modal-update-tariff')
export class swsModalUpdateTariff extends LitElement {

    @property({ type: Number })
    tariffData: any = "";

    @property({ type: Number})
    productType?: number;

    @property({ type: String})
    productName: string = '';

    @property({ type: Object})
    deliveryData = {};

    @property({type: Number})
    customerType = 0;

    @property({type: Array})
    settings: Record<string, any> = {};

    // Define the product types 0
    @property({type: Boolean})
    productType_0 = false;

    @property({type: String})
    productType_0_yearly = '';

    @property({type: String})
    productType_0_space = '';

    // Define the product types 1
    @property({type: Boolean})
    productType_1 = false;

    @property({type: String})
    productType_1_yearly = '';

    @property({type: String})
    productType_1_space = '';

    // Define the product types 2
    @property({type: Boolean})
    productType_2 = false;

    @property({type: String})
    productType_2_yearly = '';

    @property({type: String})
    productType_2_people = '';

    @property({type: Boolean})
    productType_2_chargeCar = false;

    @property({type: String})
    selectedTabUid = '';

    @property({type: Number})
    index = 0;

    tariffGetBasePrice(tariff: Tariff, consumption: number): number {
        if (tariff.tariff.base_price.length > 1) {
            let base_price = 0;
            for (let i = 0; i < tariff.tariff.base_price.length; i++) {
                if (tariff.tariff.base_price[i]['consumption_level'] != null && consumption >= tariff.tariff.base_price[i]['consumption_level']) {
                    base_price = tariff.tariff.base_price[i]['base_price'];
                }
            }
            return base_price;
        } else {
            return tariff.tariff.base_price[0]['base_price'];
        }
    }

    tariffCalculationEachMonth(consumption: number, working_price: number, base_price: number): number {
        if (consumption == 0 || working_price == 0 || base_price == 0) {
            return 0;
        }

        if (this.customerType == 1) {
            return Math.ceil(((working_price * consumption) + +base_price) / 12);
        } else {
            // return Math.floor((((working_price * consumption) + +base_price) / 12) * this.settings['tax']);
            return Math.ceil(((working_price * consumption) + +base_price) / 12);
        }
    }

    calculateTariffCosts(tariff: Tariff): number {
        let consumption = 0;
        let working_price = 0;
        let base_price = 0;

        switch (tariff.type) {
            case 0:
                if (this.productType_0_yearly && parseInt(this.productType_0_yearly) > 0) {
                    consumption = parseInt(this.productType_0_yearly);
                }else {
                    consumption = this.settings['pricing']['areaGas'][this.productType_0_space] ? this.settings['pricing']['area'][this.productType_0_space] : 0;
                }

                base_price = this.tariffGetBasePrice(tariff, consumption);
                working_price = tariff.tariff.labor_price / 100;
                break;
            case 1:
                if (this.productType_1_yearly && parseInt(this.productType_1_yearly) > 0) {
                    consumption = parseInt(this.productType_1_yearly);
                } else {
                    consumption = this.settings['pricing']['areaHeatPump'][this.productType_1_space] ? this.settings['pricing']['area'][this.productType_1_space] : 0;
                }

                base_price = this.tariffGetBasePrice(tariff, consumption);
                working_price = tariff.tariff.labor_price / 100;
                break;
            case 2:
                // Get Consumption
                if (this.productType_2_yearly && parseInt(this.productType_2_yearly) > 0) {
                    consumption = parseInt(this.productType_2_yearly);
                } else {
                    if (this.productType_2_chargeCar) {
                        consumption = this.settings['pricing']['persons']['chargesCar'][this.productType_2_people] ? this.settings['pricing']['persons']['chargesCar'][this.productType_2_people] : 0;
                    } else {
                        consumption = this.settings['pricing']['persons']['default'][this.productType_2_people] ? this.settings['pricing']['persons']['default'][this.productType_2_people] : 0;
                    }
                }

                base_price = this.tariffGetBasePrice(tariff, consumption);
                working_price = tariff.tariff.labor_price / 100;
                break;
            default:
                break;
        }

        return this.tariffCalculationEachMonth(consumption, working_price, base_price);
    }

    protected willUpdate(changedProperties: Map<string, unknown>) {
        if (changedProperties.has('productType')) {
        }
        if (changedProperties.has('productName')) {
        }
        if (changedProperties.has('tariffData')) {
        }
        this.requestUpdate();
    }

    connectedCallback() {
        super.connectedCallback();

        document.addEventListener('set-tariff-data', (e: Event) => {
            const data = (e as CustomEvent).detail;
            this.productType = data.productType;
            this.productName = data.productName;
            this.tariffData = data.tariffData;
            this.deliveryData = data.deliveryData;
            this.selectedTabUid = data.selectedTabUid;
            this.productType_0_yearly = data.tariffData.tariff.meta.yearlyConsumption || '';
            this.productType_1_yearly = data.tariffData.tariff.meta.yearlyConsumption || '';
            this.productType_2_yearly = data.tariffData.tariff.meta.yearlyConsumption || '';
            this.productType_0_space = data.tariffData.tariff.meta.space || '';
            this.productType_1_space = data.tariffData.tariff.meta.space || '';
            this.productType_2_people = data.tariffData.tariff.meta.people || '';
            this.productType_2_chargeCar = data.tariffData.tariff.meta.chargeCar || false;
            this.index = data.index || 0;

            this.requestUpdate(); // wichtig!
        });
    }

    updateDisplayedAmount = () => {
        const amountField = document.getElementById('tariff-amount');
        if (!amountField) return;

        // Nutze calculateTariffCosts mit dem aktuellen Tarif (z. B. aus this.tariffData)
        const amount = this.calculateTariffCosts(this.tariffData);

        amountField.textContent = `${formatNumber(amount, 2)} €`;
    }

    private _handleAcceptChange(e: Event) {
        e.preventDefault();

        const existingTariffs = TariffFormStore.get('allTariffs') || [];
        const newAmount = this.calculateTariffCosts(this.tariffData);

        (this.tariffData as any).tariff.price = newAmount;

        switch (this.productType) {
            case 0:
                this.tariffData.tariff.meta.space = this.productType_0_space;
                this.tariffData.tariff.meta.yearlyConsumption = this.productType_0_yearly;
                break;
            case 1:
                this.tariffData.tariff.meta.space = this.productType_1_space;
                this.tariffData.tariff.meta.yearlyConsumption = this.productType_1_yearly;
                break;
            case 2:
                this.tariffData.tariff.meta.yearlyConsumption = this.productType_2_yearly;
                this.tariffData.tariff.meta.people = this.productType_2_people;
                this.tariffData.tariff.meta.chargeCar = this.productType_2_chargeCar;
                break;
            default:
                console.error('Unbekannter Produkttyp:', this.productType);
        }

        this.tariffData.tariff.consumptionGeneral = this._getConsumptionGeneral(this.tariffData.tariff);

        if (this.selectedTabUid) {
            const event = new CustomEvent('tariff-updated-temporary', {
                detail: {
                    updatedTariff: this.tariffData,
                    tariffUid: this.selectedTabUid,
                },
                bubbles: true,
                composed: true
            });

            this.dispatchEvent(event);
        } else {

            const allTariffs = TariffFormStore.get('allTariffs') || [];
            if (allTariffs[this.index]) {
                allTariffs[this.index].data = this.tariffData;

                TariffFormStore.set('allTariffs', allTariffs);

                (swsSummaryEls as SwsSummary).updateElement();
            }
        }
    }

    private _getConsumptionGeneral(tariff: Tariff): number {
        let consumption = 0;

        switch (tariff.type) {
            case 0:
                if (this.productType_0_yearly && parseInt(this.productType_0_yearly) > 0) {
                    consumption = parseInt(this.productType_0_yearly);
                } else {
                    consumption = this.settings['pricing']['areaGas'][this.productType_0_space] || 0;
                }
                break;
            case 1:
                if (this.productType_1_yearly && parseInt(this.productType_1_yearly) > 0) {
                    consumption = parseInt(this.productType_1_yearly);
                } else {
                    consumption = this.settings['pricing']['areaHeatPump'][this.productType_1_space] || 0;
                }
                break;
            case 2:
                if (this.productType_2_yearly && parseInt(this.productType_2_yearly) > 0) {
                    consumption = parseInt(this.productType_2_yearly);
                } else {
                    if (this.productType_2_chargeCar) {
                        consumption = this.settings['pricing']['persons']['chargesCar'][this.productType_2_people] || 0;
                    } else {
                        consumption = this.settings['pricing']['persons']['default'][this.productType_2_people] || 0;
                    }
                }
                break;
        }

        return consumption;
    }


    protected createRenderRoot() {
        return this;
    }

    private _handleDeleteClick(e: Event) {
        e.preventDefault();

        const event = new CustomEvent('prepare-delete-tariff-modal', {
            detail: {
                productType: this.productType,
                productName: this.productName,
                tariffData: this.tariffData,
                deliverydata: this.deliveryData,
                selectedTabUid: this.selectedTabUid,
                index: this.index
            },
            bubbles: true,
            composed: true
        });

        this.dispatchEvent(event);
    }


    protected render()
    {
        switch (this.productType) {
            case 0:
                return html`
                    <div class="mb-3 mt-4">
                        <span class="font-18 fw-semibold">${TYPO3?.lang?.["form.chooseTariff.naturalgas.yearlyNaturalgas.label"]}</span>
                        <div class="input-group mt-3">
                            <span class="input-group-text p-0"><i class="icon-Gas icon-choose-tariff-form ms-2"></i></span>
                            <span class="form-floating">
                <input type="number" class="form-control border-end-0 border-start-0"
                       id="sws-rateCalculator-productType0-yearly" name="sws-rateCalculator-productType0-yearly" value="${this.tariffData.tariff.meta.yearlyConsumption != '0' ? this.tariffData.tariff.meta.yearlyConsumption : ''}"
                       aria-label="${TYPO3?.lang?.["form.chooseTariff.naturalgas.yearlyNaturalgas.ariaLabel"]}"
                       @input=${(e: Event) => this.productType_0_yearly = (e.target as HTMLInputElement).value}
                       @blur=${this.updateDisplayedAmount}>
                <label for="sws-rateCalculator-productType0-yearly"
                       class="form-label">${TYPO3?.lang?.["form.chooseTariff.naturalgas.yearlyNaturalgas.floatingLabel"]}</label>
            </span>
                            <span class="input-group-text text-input-gray border-start-0">${TYPO3?.lang?.["consumptionPerYear"]}</span>
                        </div>
                    </div>

                    <span class="font-18">${TYPO3?.lang?.["or"]}</span>

                    <div class="input-group mt-3">
                        <span class="input-group-text border-end-0 p-0"><i class="icon-haushalt icon-choose-tariff-form ms-2"></i></span>
                        <div class="form-floating flex-grow-1">
                            <select class="form-select border-start-0" id="sws-rateCalculator-productType0-space"
                                    aria-label="${TYPO3?.lang?.["form.livingspace.ariaLabel"]}"
                                    @change=${(e: Event) => { this.productType_0_space = (e.target as HTMLSelectElement).value; this.updateDisplayedAmount() } }>
                                <option value="cookingGas" ?selected=${this.tariffData.tariff.meta.space === 'cookingGas'}>${TYPO3?.lang?.["form.livingspace.cookingGas"]}</option>
                                <option value="30" ?selected=${this.tariffData.tariff.meta.space === '30'}>${TYPO3?.lang?.["form.livingspace.30"]}</option>
                                <option value="50" ?selected=${this.tariffData.tariff.meta.space === '50'}>${TYPO3?.lang?.["form.livingspace.50"]}</option>
                                <option value="100" ?selected=${this.tariffData.tariff.meta.space === '100'}>${TYPO3?.lang?.["form.livingspace.100"]}</option>
                                <option value="120" ?selected=${this.tariffData.tariff.meta.space === '120'}>${TYPO3?.lang?.["form.livingspace.120"]}</option>
                                <option value="200" ?selected=${this.tariffData.tariff.meta.space === '200'}>${TYPO3?.lang?.["form.livingspace.200"]}</option>
                            </select>
                            <label for="sws-rateCalculator-productType0-space">${TYPO3?.lang?.["form.livingspace.label"]}</label>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mt-4">
                        <h2 class="font-18 fw-bold m-0">${TYPO3?.lang?.["modal.updateTariff.newMonthly"]}</h2>
                        <h2 class="font-18 fw-bold m-0" id="tariff-amount">${formatNumber(this.tariffData.tariff.price, 2)} €</h2>
                    </div>
                    <p>${TYPO3?.lang?.["modal.updateTariff.newMonthly.infobox"]} ${this.productName}</p>
                    <div class="w-100 d-grid mt-4 d-flex flex-column">
                        <button class="btn btn-primary w-100 mx-md-0 mb-4 text-white" data-bs-dismiss="modal" @click=${this._handleAcceptChange}>${TYPO3?.lang?.["modal.updateTariff.acceptChange"]}</button>
                        <a href="#" class="btn btn-link btn-back text-muted" data-bs-target="#modal-cancel-tariff" @click=${(e: Event) => this._handleDeleteClick(e)}
                           data-bs-toggle="modal">${TYPO3?.lang?.["modal.updateTariff.delete"]}</a>
                    </div>
                `;
            case 1:
                return html`
                    <div class="mb-3 mt-4">
                        <span class="font-18 fw-semibold">${TYPO3?.lang?.["form.chooseTariff.heatpump.yearlyHeatpump.label"]}</span>
                        <div class="input-group mt-3">
                            <span class="input-group-text p-0"><i class="icon-Heizung icon-choose-tariff-form ms-2"></i></span>
                            <span class="form-floating">
                <input type="number" class="form-control border-end-0 border-start-0"
                       id="sws-rateCalculator-productType1-yearly" name="sws-rateCalculator-productType1-yearly" value="${this.tariffData.tariff.meta.yearlyConsumption != '0' ? this.tariffData.tariff.meta.yearlyConsumption : ''}"
                       aria-label="${TYPO3?.lang?.["form.chooseTariff.heatpump.yearlyHeatpump.ariaLabel"]}"
                       @input=${(e: Event) => this.productType_1_yearly = (e.target as HTMLInputElement).value}
                       @blur=${this.updateDisplayedAmount}>
                <label for="sws-rateCalculator-productType1-yearly"
                       class="form-label">${TYPO3?.lang?.["form.chooseTariff.heatpump.yearlyHeatpump.floatingLabel"]}</label>
            </span>
                            <span class="input-group-text text-input-gray border-start-0">${TYPO3?.lang?.["consumptionPerYear"]}</span>
                        </div>
                    </div>

                    <span class="font-18">${TYPO3?.lang?.["or"]}</span>

                    <div class="input-group mt-3">
                        <span class="input-group-text border-end-0 p-0"><i class="icon-haushalt icon-choose-tariff-form ms-2"></i></span>
                        <div class="form-floating flex-grow-1">
                            <select class="form-select border-start-0" id="sws-rateCalculator-productType1-space"
                                    name="sws-rateCalculator-productType1-space"
                                    aria-label="${TYPO3?.lang?.["form.livingspace.ariaLabel"]}"
                                    @change=${(e: Event) => { this.productType_1_space = (e.target as HTMLSelectElement).value; this.updateDisplayedAmount() }}>
                                <option value="30" ?selected=${this.tariffData.tariff.meta.space === '30'}>${TYPO3?.lang?.["form.livingspace.30"]}</option>
                                <option value="50" ?selected=${this.tariffData.tariff.meta.space === '50'}>${TYPO3?.lang?.["form.livingspace.50"]}</option>
                                <option value="100" ?selected=${this.tariffData.tariff.meta.space === '100'}>${TYPO3?.lang?.["form.livingspace.100"]}</option>
                                <option value="120" ?selected=${this.tariffData.tariff.meta.space === '120'}>${TYPO3?.lang?.["form.livingspace.120"]}</option>
                                <option value="200" ?selected=${this.tariffData.tariff.meta.space === '200'}>${TYPO3?.lang?.["form.livingspace.200"]}</option>
                            </select>
                            <label for="sws-rateCalculator-productType1-space">${TYPO3?.lang?.["form.chooseTariff.heatpump.livingspace.label"]}</label>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mt-4">
                        <h2 class="font-18 fw-bold m-0">${TYPO3?.lang?.["modal.updateTariff.newMonthly"]}</h2>
                        <h2 class="font-18 fw-bold m-0" id="tariff-amount">${formatNumber(this.tariffData.tariff.price, 2)} €</h2>
                    </div>
                    <p>${TYPO3?.lang?.["modal.updateTariff.newMonthly.infobox"]} ${this.productName}</p>
                    <div class="w-100 d-grid mt-4 d-flex flex-column">
                        <button class="btn btn-primary w-100 mx-md-0 mb-4 text-white" data-bs-dismiss="modal" @click=${this._handleAcceptChange}>${TYPO3?.lang?.["modal.updateTariff.acceptChange"]}</button>
                        <a href="#" class="btn btn-link btn-back text-muted" data-bs-target="#modal-cancel-tariff" @click=${(e: Event) => this._handleDeleteClick(e)}
                           data-bs-toggle="modal">${TYPO3?.lang?.["modal.updateTariff.delete"]}</a>
                    </div>
                `;
            case 2:
                return html`
                    <div class="mb-3 mt-4">
                        <span class="font-18 fw-semibold">${TYPO3?.lang?.["form.chooseTariff.greenElectricity.yearlyElectricity.label"]}</span>
                        <div class="input-group mt-3">
                            <span class="input-group-text border-end-0 p-0"><i class="icon-Heizung icon-choose-tariff-form ms-2"></i></span>
                            <span class="form-floating">
                                <input type="number" class="form-control border-end-0 border-start-0"
                                       name="sws-rateCalculator-productType2-yearly" id="sws-rateCalculator-productType2-yearly" value="${this.tariffData.tariff.meta.yearlyConsumption != '0' ? this.tariffData.tariff.meta.yearlyConsumption : ''}"
                                       aria-label="${TYPO3?.lang?.["form.chooseTariff.greenElectricity.yearlyElectricity.ariaLabel"]}"
                                       @input=${(e: Event) => this.productType_2_yearly = (e.target as HTMLInputElement).value}
                                       @blur=${this.updateDisplayedAmount}>
                                <label for="sws-rateCalculator-productType2-yearly"
                                       class="form-label">${TYPO3?.lang?.["form.chooseTariff.greenElectricity.yearlyElectricity.floatingLabel"]}</label>
                            </span>
                            <span class="input-group-text text-input-gray border-start-0">${TYPO3?.lang?.["consumptionPerYear"]}</span>
                        </div>
                    </div>

                    <span class="font-18">${TYPO3?.lang?.["or"]}</span>

                    <div class="input-group mt-3">
                        <span class="input-group-text border-end-0 p-0"><i class="icon-bewohner-benutzer icon-choose-tariff-form ms-2"></i></span>
                        <div class="form-floating flex-grow-1">
                            <select class="form-select border-start-0" id="sws-rateCalculator-productType2-people"
                                    name="sws-rateCalculator-productType2-people"
                                    aria-label="${TYPO3?.lang?.["form.numberPersons.ariaLabel"]}"
                                    @change=${(e: Event) => { this.productType_2_people = (e.target as HTMLSelectElement).value; this.updateDisplayedAmount() } }>
                                <option value="1" ?selected=${this.tariffData.tariff.meta.people === '1'}>
                                    ${TYPO3?.lang?.["form.numberPersons.onePerson"]}
                                </option>
                                <option value="2" ?selected=${this.tariffData.tariff.meta.people === '2'}>
                                    ${TYPO3?.lang?.["form.numberPersons.twoPersons"]}
                                </option>
                                <option value="3" ?selected=${this.tariffData.tariff.meta.people === '3'}>
                                    ${TYPO3?.lang?.["form.numberPersons.threePersons"]}
                                </option>
                                <option value="4" ?selected=${this.tariffData.tariff.meta.people === '4'}>
                                    ${TYPO3?.lang?.["form.numberPersons.fourPersons"]}
                                </option>
                                <option value="5" ?selected=${this.tariffData.tariff.meta.people === '5'}>
                                    ${TYPO3?.lang?.["form.numberPersons.fivePersons"]}
                                </option>
                            </select>
                            <label for="sws-rateCalculator-productType2-people">${TYPO3?.lang?.["form.numberPersons.label"]}</label>
                        </div>
                    </div>


                    <div class="form-check d-flex align-items-center mt-4">
                        <input class="form-check-input me-2" type="checkbox" value=""
                               id="sws-rateCalculator-productType2-chargeCar"
                               name="sws-rateCalculator-productType2-chargeCar"
                               ?checked=${this.tariffData.tariff.meta.chargeCar}
                               @change=${(e: Event) => { this.productType_2_chargeCar = (e.target as HTMLInputElement).checked; this.updateDisplayedAmount() } }>
                        <label class="form-check-label" for="sws-rateCalculator-productType2-chargeCar"
                               aria-label="${TYPO3?.lang?.["form.chooseTariff.greenElectricity.ownAnElectricCar.ariaLabel"]}">
                            ${TYPO3?.lang?.["form.chooseTariff.greenElectricity.ownAnElectricCar.label"]}
                        </label>
                    </div>
                    <div class="d-flex justify-content-between mt-4">
                        <h2 class="font-18 fw-bold m-0">${TYPO3?.lang?.["modal.updateTariff.newMonthly"]}</h2>
                        <h2 class="font-18 fw-bold m-0" id="tariff-amount">${formatNumber(this.tariffData.tariff.price, 2)} €</h2>
                    </div>
                    <p>${TYPO3?.lang?.["modal.updateTariff.newMonthly.infobox"]} ${this.productName}</p>
                    <div class="w-100 d-grid mt-4 d-flex flex-column">
                        <button class="btn btn-primary w-100 mx-md-0 mb-4 text-white" data-bs-dismiss="modal" @click=${this._handleAcceptChange}>${TYPO3?.lang?.["modal.updateTariff.acceptChange"]}</button>
                        <a href="#"
                           class="btn btn-link btn-back text-muted"
                           @click=${(e: Event) => this._handleDeleteClick(e)}>
                            ${TYPO3?.lang?.["modal.updateTariff.delete"]}
                        </a>




                    </div>
                `;
            default:
                return html`${TYPO3?.lang?.["modal.updateTariff.noTariff"]}`;


        }
    }
}
